import { Fragment, useState, useEffect } from "react";
import Header from "../../layouts/Header";
import { useHistory } from "react-router-dom";
import "../../assets/styles/local/payrollTimeSheet.css";
import { Box } from "@mui/material";
import Expand from "../../assets/icons/Expand.svg";
import Group from "../../assets/icons/Group_3100.svg";
import clock from "../../assets/images/clock-hover.svg";
import Print from "../../assets/icons/Print_icon.svg";
import ArrowIcon from "../../assets/icons/arrowdown.svg";
import Clock from "../../assets/icons/Path 598.svg";
import edit from "../../assets/icons/edit-2.svg";
import trash from "../../assets/icons/DeleteIcon.svg";
import { motion, AnimatePresence } from "framer-motion";
import simpleRequest from "../../utils/helpers/simpleRequest";
import moment from "moment";
import { approveWorktimeReport } from "../../redux/actions/worktimeActions";
import { fetchScreenTranslations } from "../../utils/helpers/translations";
import { convertToPDF } from "../../utils/helpers/pdfService";

const PayrollTimeSheet = () => {
  const history = useHistory();
  const [activeTab, setActiveTab] = useState(0);
  const [expands, setExpands] = useState([]);
  const [payrollData, setPayrollData] = useState([]);
  const currentWeekNumber = moment().isoWeek();
  const [pageNumber, setPageNumber] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  const companyId = window.localStorage.getItem("companyid");

  const fetchPayrollDetails = async () => {
    let url = `/api/TimeManagement/GetWorktimeReport?`;
    url = `${url}pageNumber=${pageNumber}&recordPerPage=${itemsPerPage}&companyId=${companyId}`;
    const res = await simpleRequest(url);
    if (res?.status === true) {
      let payroll = res.data || [];

      // APPROVED
      if (activeTab === 1) {
        payroll = payroll.filter((x) =>
          x.dateWiseTasksList[0].some((t) => t.isApproved),
        );
      }

      // UNAPPROVED
      if (activeTab === 2) {
        payroll = payroll.filter((x) =>
          x.dateWiseTasksList[0].some((t) => !t.isApproved),
        );
      }

      setPayrollData(payroll);
    }
  };

  const [FetchTranslationList, setFetchTranslationList] = useState({});
  const t = (key) => FetchTranslationList?.[key] || "";
  useEffect(() => {
    fetchScreenTranslations("Payroll").then((data) =>
      setFetchTranslationList(data),
    );
  }, []);

  const getTotalHours = (data) => {
    let totalMinutes = 0;
    data.dateWiseTasksList.forEach((el) => {
      el.forEach((a) => {
        totalMinutes += Math.round(a.totalHours * 60);
      });
    });
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
    const totalString = `${hours}:${minutes.toString().padStart(2, "0")}`;
    return totalString;
  };

  const getTotalWage = (data) => {
    let total = 0;
    data.dateWiseTasksList.forEach((el) => {
      el.forEach((a) => {
        total = total + a.totalHours;
      });
    });
    const roundedTotal = parseFloat(total.toFixed(2));
    const totalWage = roundedTotal * data.wage;
    const roundedWage = parseFloat(totalWage.toFixed(2));
    return roundedWage;
  };

  const getDifference = (data) => {
    let totalHours = 0;

    data.dateWiseTasksList.forEach((el) => {
      el.forEach((a) => {
        totalHours += a.totalHours;
      });
    });
    const roundedTotalHours = parseFloat(totalHours.toFixed(2));
    const differenceHours = roundedTotalHours - data.weekHrs;
    const hours = Math.floor(Math.abs(differenceHours));
    const rawMinutes = (Math.abs(differenceHours) * 60) % 60;
    const roundedMinutes = parseFloat(rawMinutes.toFixed(2));
    const minutes = Math.floor(roundedMinutes);
    const sign = differenceHours >= 0 ? "+" : "-";
    const totalString = `${sign}${hours}:${minutes
      .toString()
      .padStart(2, "0")}`;
    return totalString;
  };

  const handleApproveAll = () => {
    payrollData?.map((item) => approveWorktimeReport(item?.userId));
    let list = new Array();
    payrollData.map((item) => {
      const newItem = { ...item };
      let newList = [];
      item?.dateWiseTasksList?.map((item2) => {
        let newList2 = [];
        item2?.map((item3) => {
          newList2.push({ ...item3, isApproved: !item3?.isApproved });
        });
        newList.push(newList2);
      });
      newItem["dateWiseTasksList"] = newList;
      list.push(newItem);
    });
    setPayrollData([...list]);
  };

  useEffect(() => {
    fetchPayrollDetails();
  }, [pageNumber, itemsPerPage, activeTab]);

  return (
    <Fragment>
      <Header
        leftComponent={
          <Box component="div" className="products-and-parts-header-content">
            <Box
              component="div"
              className="products-and-parts-main-title  cursor-pointer"
              onClick={() => history.push("/payroll")}
            >
              {/* Payroll */}
              {t("Payroll")}
            </Box>
            <p className="products-and-parts-sub-title products_and_parts_sub_title">
              {/* Timesheets */}
              {t("Timesheets")}
            </p>
          </Box>
        }
      />
      <Box component="div" className="pts-main-div">
        <Box component="div" className="pts-div-1 frc">
          <Box component="div" className="pts-div-1-child-1">
            <Box component="div" className="pts-div-2 frc">
              <Box
                component="div"
                className="pts-active-tab-bg"
                style={{ left: `${activeTab * 33.34}%` }}
              ></Box>
              <p
                className="mb-0 pts-div-tab"
                style={{
                  color: activeTab === 0 && "#FFF",
                  fontWeight: activeTab === 0 && 700,
                }}
                onClick={() => setActiveTab(0)}
              >
                {/* All */}
                {t("All")}
              </p>
              <p
                className="mb-0 pts-div-tab"
                style={{
                  color: activeTab === 1 && "#FFF",
                  fontWeight: activeTab === 1 && 700,
                }}
                onClick={() => setActiveTab(1)}
              >
                {/* Approved */}
                {t("Approved")}
              </p>
              <p
                className="mb-0 pts-div-tab"
                style={{
                  color: activeTab === 2 && "#FFF",
                  fontWeight: activeTab === 2 && 700,
                }}
                onClick={() => setActiveTab(2)}
              >
                {/* Unapproved */}
                {t("Unapproved")}
              </p>
            </Box>
          </Box>
        </Box>
        <Box component="div" className="frcb pts-box-2">
          <Box component="div" className="frc pts-box-2-c-1">
            <p className="pts-pay-period-text">
              {/* Pay Period: */}
              {t("Pay period")}
            </p>
            <p className="pts-pay-period-time">
              {moment().clone().day("Sunday").format("DD MMM")} -{" "}
              {moment().endOf("isoWeek").format("DD MMM")}
            </p>
          </Box>
          <Box component="div" className="frc pts-box-2-c-2">
            <Box
              component="div"
              className="pts-expand-box frc"
              onClick={() => {
                if (expands?.length > 0) return setExpands([]);
                const list = [];
                Array.from({ length: 5 }, (_, v) => {
                  list.push(`${v}`);
                });
                setExpands([...list]);
              }}
            >
              <img src={Expand} alt="Expand Icon" />
              <p className="mb-0">
                {/* Expand */}
                {t("Expand")}
              </p>
            </Box>
            <Box
              component="div"
              className="pts-expand-box frc"
              onClick={handleApproveAll}
            >
              <img src={Group} alt="Approve all Icon" />
              <p className="mb-0">
                {/* Approve All */}
                {t("Approve All")}
              </p>
            </Box>
          </Box>
        </Box>
        <Box component="div" style={{ overflow: "auto" }}>
          <Box className="fc pts-main-box-flex">
            {payrollData?.map((item, i) => (
              <SingleTimeSheet
                key={i}
                expands={expands}
                setExpands={setExpands}
                index={i}
                item={item}
                currentWeekNumber={currentWeekNumber}
                getTotalHours={getTotalHours}
                getTotalWage={getTotalWage}
                getDifference={getDifference}
                payrollData={payrollData}
                setPayrollData={setPayrollData}
              />
            ))}
          </Box>
        </Box>
      </Box>
    </Fragment>
  );
};

export default PayrollTimeSheet;

const SingleTimeSheet = ({
  expands,
  setExpands,
  index,
  item,
  currentWeekNumber,
  getTotalHours,
  getTotalWage,
  getDifference,
  payrollData,
  setPayrollData,
}) => {
  const handleExpand = () => {
    const list = [...expands];
    if (list?.find((item) => item === `${index}`)) {
      const ind = list.findIndex((item) => item === `${index}`);
      list.splice(ind, 1);
    } else list.push(index.toString());
    setExpands([...list]);
  };

  const [FetchTranslationList, setFetchTranslationList] = useState({});
  const t = (key) => FetchTranslationList?.[key] || "";
  useEffect(() => {
    fetchScreenTranslations("Payroll").then((data) =>
      setFetchTranslationList(data),
    );
  }, []);

  const handleApprove = async () => {
    let list = new Array();
    payrollData.map((mainItem) => {
      const newItem = { ...mainItem };
      let newList = [];
      mainItem?.dateWiseTasksList?.map((item2) => {
        let newList2 = [];
        item2?.map((item3) => {
          newList2.push({
            ...item3,
            isApproved:
              mainItem?.userId === item?.userId
                ? !item3?.isApproved
                : item3?.isApproved,
          });
        });
        newList.push(newList2);
      });
      newItem["dateWiseTasksList"] = newList;
      list.push(newItem);
    });
    setPayrollData([...list]);
    await approveWorktimeReport(item?.userId);
  };

  // for payroll pdf
  const handleSinglePrint = async (report, format) => {
    const reportList = [{ ...report }];

    // let ASCexcelData = [{ ...report }];
    // delete ASCexcelData[0].dateWiseTasksList; // Remove dateWiseTasksList.

    let storedData = [{ ...report }];
    let ASCexcelData = storedData[0].dateWiseTasksList;
    console.log("asc456 payroll", ASCexcelData);

    switch (format) {
      case "pdf":
        convertToPDF(reportList);
        break;
      case "csv":
        // generateCSV(reportList);
        break;
      case "xlsx":
        // convertToExcel(reportList);
        // convertToExcel(reportList, "worktime-underData", ASCexcelData);
        break;
      default:
        alert("Unsupported file format");
    }
  };

  return (
    <Box component="div" className="pts-main-box">
      <Box component="div" className="pts-main-box-topbar">
        <Box component="div" className="pts-topbar-coworker frc">
          {item?.imageUrl ? (
            <img src={item?.imageUrl} alt="Coworker Image" />
          ) : (
            <Box component="div" className="pts-topbar-coworker-abv">
              {item?.firstName?.[0]}
              {item?.firstName?.[1]}
            </Box>
          )}
          <p>
            {item?.firstName} {item?.lastName}
          </p>
        </Box>
        <p className="mb-0 pts-topbar-regular">{item?.weekHrs}H</p>
        <Box component="div" className="pts-topbar-week-total-box">
          <p className="mb-0 pts-topbar-bold">
            {/* Week  */}
            {t("Week")}
            {currentWeekNumber}
          </p>
          <p className="mb-0 pts-topbar-regular">
            {/* Totals */}
            {t("Totals")}
          </p>
        </Box>
        <Box component="div" className="frc pts-box-2-c-1">
          <img src={clock} alt="Clock Icon" />
          <p className="mb-0 pts-topbar-semibold">{getTotalHours(item)}</p>
        </Box>
        <Box component="div" className="pts-topbar-week-total-box">
          <p className="mb-0 pts-topbar-semibold">€ {getTotalWage(item)}</p>
          <p className="mb-0 pts-topbar-semibold">{getDifference(item)}</p>
        </Box>
        <Box component="div" className="pts-topbar-approve-box frc">
          <p className="mb-0 pts-topbar-semibold">Approve</p>
          <Box
            component="div"
            className="pts-topbar-approve-btn"
            style={{
              background:
                item?.dateWiseTasksList?.[0]?.[0]?.isApproved &&
                "linear-gradient(179deg, rgb(0, 36, 106), rgb(149, 167, 198))",
              border: item?.dateWiseTasksList?.[0]?.[0]?.isApproved
                ? "none"
                : "0.5px solid #00000026",
            }}
            onClick={handleApprove}
          ></Box>
        </Box>
        <Box component="div" className="pts-topbar-print-box">
          <img
            src={Print}
            alt="Print Icon"
            onClick={() => {
              handleSinglePrint(item, "pdf");
              localStorage.setItem(
                "clientNameForPrint",
                `${item.firstName ?? ""} ${item.lastName ?? ""}`,
              );
            }}
          />
          <img
            src={ArrowIcon}
            alt="Arrow Icon"
            width={16}
            height={16}
            style={{
              transform:
                expands.find((item) => item === `${index}`) && "rotate(180deg)",
            }}
            onClick={handleExpand}
          />
        </Box>
      </Box>
      <AnimatePresence>
        {expands.find((item) => item === `${index}`) && (
          <motion.div
            initial={{ height: 0, overflow: "hidden" }}
            animate={{ height: "auto", overflow: "hidden" }}
            exit={{ height: 0, overflow: "hidden" }}
            className="last-child-none"
          >
            <Box
              component="div"
              className="pts-main-box-topbar pts-mainbox-toprow"
            >
              <Box component="div" className="pts-toprow-day-type-grid">
                <p className="mb-0 pts-topbar-regular">
                  {/* Day */}
                  {t("Day")}
                </p>
                <p className="mb-0 pts-topbar-regular">
                  {/* Type */}
                  {t("Type")}
                </p>
              </Box>
              <p className="mb-0 pts-topbar-regular">
                {/* Project */}
                {t("project")}
              </p>
              <p className="mb-0 pts-topbar-regular">
                {/* Section */}
                {t("Section")}
              </p>
              <p className="mb-0 pts-topbar-regular time-center">
                {/* Time */}
                {t("Time")}
              </p>
              <p className="mb-0 pts-topbar-regular">
                {/* Task Description */}
                {t("Task Description")}
              </p>
              <p className="mb-0"></p>
              <Box component="div" className="frc pts-toprow-clock-box d-none">
                <img src={Clock} alt="Clock Icon" width={20} height={20} />
                <p className="mb-0 pts-topbar-regular add-time-color">
                  {/* Add time */}
                  {t("Add time")}
                </p>
              </Box>
            </Box>
            {item?.dateWiseTasksList
              ?.sort(
                (a, b) =>
                  new Date(a[0]?.trackerStartDate) -
                  new Date(b[0]?.trackerStartDate),
              )
              ?.map((item, index) => {
                return <SingleTime key={index} item={item} />;
              })}
          </motion.div>
        )}
      </AnimatePresence>
    </Box>
  );
};

const SingleTime = ({ item }) => {
  const [expand, setExpand] = useState(false);
  return (
    <Fragment>
      <Box
        component="div"
        className="pts-main-box-topbar pts-mainbox-toprow cursor-pointer"
        onClick={() => setExpand(!expand)}
      >
        <Box component="div" className="pts-toprow-day-type-grid">
          <p className="mb-0 pts-topbar-regular">
            {moment(new Date(item?.[0]?.trackerStartDate)).format("ddd")}{" "}
            <span className="pts-topbar-bold">
              {item?.[0]?.trackerStartDate}
            </span>
          </p>
          <p className="mb-0 pts-topbar-regular"></p>
        </Box>
        <p className="mb-0 pts-topbar-regular"></p>
        <p className="mb-0 pts-topbar-regular"></p>
        <p className="mb-0 pts-topbar-bold time-center">{item?.totalHours}</p>
        <p className="mb-0 pts-topbar-regular"></p>
        <p className="mb-0"></p>
        <Box component="div" className="frc pts-toprow-clock-box"></Box>
      </Box>
      <AnimatePresence>
        {expand && (
          <motion.div
            initial={{ height: 0, overflow: "hidden" }}
            animate={{ height: "auto", overflow: "hidden" }}
            exit={{ height: 0, overflow: "hidden" }}
          >
            {item?.map((singleTask, innerIndex) => {
              return (
                <SingleTimeDetails key={innerIndex} singleTask={singleTask} />
              );
            })}
          </motion.div>
        )}
      </AnimatePresence>
    </Fragment>
  );
};

const SingleTimeDetails = ({ singleTask }) => {
  const getHours = (hrs) => {
    const totalMinutes = Math.round(hrs * 60);
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
    return `${hours}:${minutes.toString().padStart(2, "0")}`;
  };

  return (
    <Box component="div" className="pts-main-box-topbar pts-mainbox-row-2">
      <Box component="div" className="pts-grid-left"></Box>
      <Box component="div" className="pts-grid-right">
        <p className="mb-0 pts-row-regular-dark">{singleTask?.type}</p>
        <p className="mb-0 pts-row-regular-dark truncate">
          {singleTask?.projectName}
        </p>
        <p className="mb-0 pts-row-regular-dark truncate">
          {singleTask?.taskName}
        </p>
        <p className="mb-0 pts-row-regular-dark time-center">
          {getHours(singleTask?.totalHours)}
        </p>
        <p className="mb-0 pts-row-regular-dark truncate">
          {singleTask?.description}
        </p>
        <Box component="div" className="frc pts-row-action-box d-none">
          <img src={edit} alt="Edit Icon" height={16} width={16} />
          <img src={trash} alt="Delete Icon" height={16} width={16} />
        </Box>
      </Box>
    </Box>
  );
};
